import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Categories from "../../Components/seperate Components/Categories";
import axios from "axios";
// import img1 from "../../assets/All Images/hire-destintion.jpg";
// import img2 from "../../assets/All Images/hire-strategies.jpg";
// import img3 from "../../assets/All Images/hire-challenges.jpg";
import moment from "moment/moment";

const RecentPost = () => {
  const { permalink } = useParams();
  const [post, SetPost] = useState([]);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const { data } = await axios.get("https://mars.zithas.com/api/blog");
        SetPost(data);
        setLoading(false);
      } catch (err) {
        console.error(err);
      }
    };
    fetch();
  }, []);

  return (
    <div className="col-lg-4 rescentPost-responsive">
      <div className="ablog__sidebar mb-40">
        <div className="widget mb-45">
          <h3 className="sidebar__widget--title mb-30">Recent Posts</h3>
          <div className="sidebar--widget__post mb-20">
            <div className="sidebar__post--thumb">
              <Link to={`/blog/blog-details`}>
                <div className="post__img">
                  <img className="post"
                  //  src={img1} 
                   />
                </div>
              </Link>
            </div>
            <div className="sidebar__post--text">
              <h4 className="sidebar__post--title">
                <Link to={`/blog/blog-details`}>
                  Is the Perfect Destination to Hire Skilled Resources for Your
                  Business
                </Link>
              </h4>
              {/* <span
                style={{ color: "var(--clr-body-text)", fontWeight: "400" }}
              >
                Feb 11, 2024
              </span> */}
            </div>
          </div>
          <div className="sidebar--widget__post mb-20">
            <div className="sidebar__post--thumb">
              <Link to={`/blog/blog-details`}>
                <div className="post__img">
                  <img className="post"
                  //  src={img2} 
                   />
                </div>
              </Link>
            </div>
            <div className="sidebar__post--text">
              <h4 className="sidebar__post--title">
                <Link to={`/blog/blog-details`}>
                  Top Strategies for Hiring IT Resources: A Guide for Global
                  Companies
                </Link>
              </h4>
              {/* <span
                style={{ color: "var(--clr-body-text)", fontWeight: "400" }}
              >
                Feb 9, 2024
              </span> */}
            </div>
          </div>
          <div className="sidebar--widget__post mb-20">
            <div className="sidebar__post--thumb">
              <Link to={`/blog/blog-details`}>
                <div className="post__img">
                  <img className="post"
                  //  src={img3} 
                   />
                </div>
              </Link>
            </div>
            <div className="sidebar__post--text">
              <h4 className="sidebar__post--title">
                <Link to={`/blog/blog-details`}>
                  Navigating the Challenges of Hiring Resources
                </Link>
              </h4>
              {/* <span
                style={{ color: "var(--clr-body-text)", fontWeight: "400" }}
              >
                Feb 7, 2024
              </span> */}
            </div>
          </div>
        </div>
      </div>

      {/* <Categories /> */}
    </div>
  );
};

export default RecentPost;
